import CatalogFragment from '@square/dashboard-items-data/serializers/connect/catalog-fragment';
export default class FoodAndBeverageDetails extends CatalogFragment {}